import React from "react";
import "assets/styles/global.scss";
import MainVote from "components/pages/MainVote";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import ModalViewVotes from "components/UI/Modal/ModalViewVotes";

const App: React.FC = () => {
    const location = useLocation();
    let state = location.state as { backgroundLocation?: Location };

    return (
        <div className="App">
            <Routes>
                <Route path="/season1/voting/" element={<MainVote/>}/>
                <Route path="/season1/voting/view-votes/:id" element={<MainVote/>}/>
                <Route path="*" element={<Navigate to="/season1/voting/"/>}/>
            </Routes>
            {
                state?.backgroundLocation && (
                    <Routes>
                        <Route path="/season1/voting/view-votes/:id" element={<ModalViewVotes/>}/>
                    </Routes>
                )
            }
        </div>
    );
};

export default App;